export default "__VITE_ASSET__D5vkdh0S__"